import { DayOfWeek } from '@weareopenr/types';
import { IMenuSchedule, IPriceSchemeSchedule, ITimetableDetail, ITimetableSchedule } from 'src/api/getTimetable';
import type { ITimetableDaySchedule } from './groupSchedulesByDay';

export type { IMenuSchedule, IPriceSchemeSchedule };

export const DAY_OF_WEEK_ORDER = Object.values(DayOfWeek);

export const isMenuSchedule = (schedule: ITimetableSchedule): schedule is IMenuSchedule => schedule.menu_id !== null;

export const isPriceSchemeSchedule = (schedule: ITimetableSchedule): schedule is IPriceSchemeSchedule =>
  schedule.price_scheme_id !== null;

export type TimetableEntityType = 'menu' | 'priceScheme';

export const getEntityType = (schedule: ITimetableSchedule): TimetableEntityType =>
  isMenuSchedule(schedule) ? 'menu' : 'priceScheme';

export const getEntityId = (schedule: ITimetableSchedule): string =>
  isMenuSchedule(schedule) ? schedule.menu_id : schedule.price_scheme_id;

export const isDefaultSchedule = (schedule: ITimetableSchedule, timetable: ITimetableDetail): boolean =>
  isMenuSchedule(schedule)
    ? schedule.menu_id === timetable.default_menu_id
    : schedule.price_scheme_id === timetable.default_price_scheme_id;

// `fr` tracks split the space left after gaps are subtracted - unlike `%`, which ignores gaps.
export const toGridTemplateColumns = (items: ITimetableDaySchedule[]): string =>
  items.map((item) => `minmax(0, ${item.dayPercent}fr)`).join(' ');
